import styled from '@emotion/styled';
import { Magnetic as Mi } from '@mitchell/react.component.ux';
export const StyledRow = styled('div') `
	margin-bottom: ${Mi.spacer04};
`;
export const StyledNoRecordDiv = styled('div') `
	display: flex;
	justify-content: center;
	color: ${Mi.colorBlack};
`;
export const StyledZipValidationDiv = styled('p') `
	display: flex;
	color: ${Mi.colorRed};
`;
export const StyledSearchBox = styled('div') `
	margin-bottom: ${Mi.spacer06};
`;
export const StyledResourceListContainer = styled('div') `
	max-height: 50vh;
	overflow-y: auto;
	margin-bottom: ${Mi.spacer04};
`;
//# sourceMappingURL=RepairResourceLookupComponent.style.js.map